import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    setTimeout(this.animate, 5000, this.element)
  }

  animate(element) {
    element.classList.add("flash--fade_out")
  }

  remove() {
    this.element.remove()
  }
}
